import React, { useEffect, useState } from "react";
import { fetchBooks } from "../lib/api";
import { Skeleton } from "../components/ui/skeleton";
import { ShoppingBag } from "lucide-react";

export default function Livros() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBooks().then(setBooks).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto section-padding py-8" data-testid="books-page">
      <div className="mb-10">
        <p className="text-[10px] uppercase tracking-[0.3em] text-navy/50">Biblioteca</p>
        <h1 className="font-display text-4xl sm:text-5xl text-navy mt-2">Livros & E-books</h1>
        <p className="text-navy/70 mt-3 max-w-2xl">
          Obras dedicadas ao aprofundamento da vida devocional e do exercício ministerial.
        </p>
      </div>

      {loading ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-96 rounded-2xl" />
          ))}
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {books.map((b) => (
            <article
              key={b.id}
              data-testid={`book-item-${b.id}`}
              className="bg-white border border-border rounded-2xl overflow-hidden card-lift flex flex-col"
            >
              <div className="aspect-[3/4] bg-[hsl(var(--parchment))] overflow-hidden">
                {b.cover_url ? (
                  <img
                    src={b.cover_url}
                    alt={b.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-navy/30 font-display text-2xl">
                    {b.title[0]}
                  </div>
                )}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-display text-xl text-navy leading-snug">{b.title}</h3>
                <p className="mt-2 text-sm text-navy/70 line-clamp-3 flex-1">{b.description}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="font-display text-lg text-navy">{b.price}</span>
                  <a
                    href={b.buy_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`book-buy-${b.id}`}
                    className="inline-flex items-center gap-2 text-xs uppercase tracking-widest bg-navy text-white px-4 py-2.5 rounded-full hover:bg-gold hover:text-navy transition-colors"
                  >
                    <ShoppingBag className="w-3.5 h-3.5" /> Comprar
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
